import { render } from "./HormoneReplacementContentEn.vue?vue&type=template&id=165468e0&scoped=true"
import script from "./HormoneReplacementContentEn.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContentEn.vue?vue&type=script&lang=js"

import "./HormoneReplacementContentEn.vue?vue&type=style&index=0&id=165468e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165468e0"]])

export default __exports__